function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.25a1.5 1.5 0 00-1.5 1.5v16.5H2.25a.75.75 0 000 1.5h19.5a.75.75 0 000-1.5H19.5V3.75a1.5 1.5 0 00-1.5-1.5H6zm12 1.5H6v16.5h12V3.75z",
    fill: props.fill
  }));
}

export default SvgDoor;